import classNames from "classnames";

import isLockerInactive from "@components/Lockers/_lib/isLockerInactive";

const LockerCardAddress = ({ locker }) => {
  const { locality, street, county } = locker.address || {};

  return (
    <>
      {(street || locality || county) && (
        <div
          className={classNames({
            "text-[#767676]": isLockerInactive(locker),
          })}
        >
          {`${street ? street + ", " : ""}${locality ? locality + ", " : ""}${
            county || ""
          }`}
        </div>
      )}
    </>
  );
};

export default LockerCardAddress;
